import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/package-return.jpg'
import _imports_1 from '@/assets/icons/return.svg'
import _imports_2 from '@/assets/icons/change.svg'
import _imports_3 from '@/assets/icons/claim.svg'


const _withScopeId = n => (_pushScopeId("data-v-ba8e7d3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "login-page" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "main-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "intro-image"
}, null, -1))
const _hoisted_5 = { class: "main-title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "card-holder" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "title-wrapper" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = {
  key: 0,
  class: "card"
}
const _hoisted_15 = { class: "title-wrapper" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "text" }
const _hoisted_19 = { class: "card" }
const _hoisted_20 = { class: "title-wrapper" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_22 = { class: "title" }
const _hoisted_23 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomInput = _resolveComponent("CustomInput")!
  const _component_LoginForm = _resolveComponent("LoginForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.change)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.t("LOGIN.INTRO_TITLE_CHANGE")), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.t("LOGIN.INTRO_TITLE")), 1))
        ])
      ]),
      _createVNode(_component_LoginForm, {
        type: "urlTypeParameter",
        loginFunction: _ctx.login,
        emailValue: _ctx.email,
        "onUpdate:emailValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
        invalid: _ctx.loginIsInvalid,
        isButtonDisabled: !_ctx.isFormFilled,
        buttonText: _ctx.t('LOGIN.NEXT'),
        loadingState: _ctx.loginLoading,
        "data-cy": "signinForm"
      }, {
        default: _withCtx(() => [
          (_ctx.urlTypeParameter === 'rma')
            ? (_openBlock(), _createBlock(_component_CustomInput, {
                key: 0,
                insideText: _ctx.ticketCode,
                "onUpdate:insideText": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ticketCode) = $event)),
                label: _ctx.t('LOGIN.TICKET_NUMBER'),
                invalid: _ctx.loginIsInvalid,
                tooltip: true,
                "data-cy": "CodeFormInput"
              }, {
                invalidText: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.invalidLabelText), 1)
                ]),
                tooltipText: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("LOGIN.TOOLTIP_FOR_TICKET")), 1)
                ]),
                _: 1
              }, 8, ["insideText", "label", "invalid"]))
            : (_openBlock(), _createBlock(_component_CustomInput, {
                key: 1,
                insideText: _ctx.orderId,
                "onUpdate:insideText": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orderId) = $event)),
                label: _ctx.t('LOGIN.ORDER_NUMBER'),
                invalid: _ctx.loginIsInvalid,
                tooltip: true,
                "data-cy": "CodeFormInput"
              }, {
                invalidText: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.invalidLabelText), 1)
                ]),
                tooltipText: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("LOGIN.TOOLTIP_FOR_ORDER")), 1)
                ]),
                _: 1
              }, 8, ["insideText", "label", "invalid"]))
        ]),
        _: 1
      }, 8, ["loginFunction", "emailValue", "invalid", "isButtonDisabled", "buttonText", "loadingState"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t("LOGIN.RETURNS_TITLE")), 1)
        ]),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.t("LOGIN.RETURNS_TEXT")), 1)
      ]),
      (!_ctx.change)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.t("LOGIN.EXCHANGE_TITLE")), 1)
            ]),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.t("LOGIN.EXCHANGE_TEXT")), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.t("LOGIN.CLAIMS_TITLE")), 1)
        ]),
        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.t("LOGIN.CLAIMS_TEXT")), 1)
      ])
    ])
  ]))
}